export const LCR_ORDER_QUERY_KEY = "lcrOrder";

const LCR_STEP_STRINGS = "orderTracking.lcr.progress.steps";

export const LCR_SHIP_STEP_LABEL_KEYS = [
  `${LCR_STEP_STRINGS}.placing`,
  `${LCR_STEP_STRINGS}.placed`,
  `${LCR_STEP_STRINGS}.processing`,
  `${LCR_STEP_STRINGS}.shipped`,
  `${LCR_STEP_STRINGS}.delivered`,
];

export const LCR_PICKUP_STEP_LABEL_KEYS = [
  `${LCR_STEP_STRINGS}.placing`,
  `${LCR_STEP_STRINGS}.placed`,
  `${LCR_STEP_STRINGS}.processing`,
  `${LCR_STEP_STRINGS}.readyForPickup`,
  `${LCR_STEP_STRINGS}.pickedUp`,
];
